export * from './core/ApiClient';
export * from './core/interceptors';
export * from './auth/AuthService';
export * from './auth/PkceService';
export * from './storage/IStorageProvider';
export * from './storage/DefaultStorageProvider';
export * from './utils/tokenHelper';
export * from './constants/endpoints';
export * from './constants/storage';
export * from './constants/errors';
export * from './errors/AuthRefreshError';
export type { AxiosInstance, AxiosRequestConfig, AxiosError, AxiosResponse } from 'axios';

import { ApiClient, ApiClientConfig } from './core/ApiClient';
import { AuthService } from './auth/AuthService';

/**
 * Creates and initializes the API client and authentication service.
 * @param config Configuration for the API client.
 * @returns An object containing the configured ApiClient and AuthService instances.
 */
export function createApiClient(config: ApiClientConfig): { apiClient: ApiClient; authService: AuthService } {
  let authServiceInstance: AuthService;

  const apiClient = new ApiClient(config, async () => {
    if (!authServiceInstance) {
      throw new Error('AuthService not initialized');
    }
    return authServiceInstance.refreshAccessToken();
  });

  authServiceInstance = new AuthService(apiClient);

  return { apiClient, authService: authServiceInstance };
}
